import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19af2d80 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b8d3170a = () => interopDefault(import('../src/pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))
const _bf54f51c = () => interopDefault(import('../src/pages/_slug/posters/index.vue' /* webpackChunkName: "pages/_slug/posters/index" */))
const _d30c4bfe = () => interopDefault(import('../src/pages/_slug/schedule/index.vue' /* webpackChunkName: "pages/_slug/schedule/index" */))
const _1d16284a = () => interopDefault(import('../src/pages/_slug/participants/index.vue' /* webpackChunkName: "pages/_slug/participants/index" */))
const _38b8fe76 = () => interopDefault(import('../src/pages/_slug/presentations/index.vue' /* webpackChunkName: "pages/_slug/presentations/index" */))
const _0b2b668f = () => interopDefault(import('../src/pages/_slug/errors/_code.vue' /* webpackChunkName: "pages/_slug/errors/_code" */))
const _070868a9 = () => interopDefault(import('../src/pages/_slug/schedule/_id.vue' /* webpackChunkName: "pages/_slug/schedule/_id" */))
const _7074959c = () => interopDefault(import('../src/pages/_slug/participants/_id.vue' /* webpackChunkName: "pages/_slug/participants/_id" */))
const _2d34f06d = () => interopDefault(import('../src/pages/_slug/presentations/_id.vue' /* webpackChunkName: "pages/_slug/presentations/_id" */))
const _60288b5f = () => interopDefault(import('../src/pages/_slug/presentations/_id/poster.vue' /* webpackChunkName: "pages/_slug/presentations/_id/poster" */))
const _23163474 = () => interopDefault(import('../src/pages/_slug/presentations/_id/slides.vue' /* webpackChunkName: "pages/_slug/presentations/_id/slides" */))
const _2c1ada6d = () => interopDefault(import('../src/pages/_slug/presentations/_id/figures.vue' /* webpackChunkName: "pages/_slug/presentations/_id/figures" */))
const _6729a059 = () => interopDefault(import('../src/pages/_slug/presentations/_id/video.vue' /* webpackChunkName: "pages/_slug/presentations/_id/video" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'higher-active',
  linkExactActiveClass: '-active-exact',
  scrollBehavior,

  routes: [{
    path: "/fr",
    component: _19af2d80,
    name: "index___fr"
  }, {
    path: "/",
    component: _19af2d80,
    name: "index___en"
  }, {
    path: "/fr/:slug",
    component: _b8d3170a,
    name: "slug___fr"
  }, {
    path: "/fr/:slug/affiches",
    component: _bf54f51c,
    name: "slug-posters___fr"
  }, {
    path: "/fr/:slug/horaire",
    component: _d30c4bfe,
    name: "slug-schedule___fr"
  }, {
    path: "/fr/:slug/participants",
    component: _1d16284a,
    name: "slug-participants___fr"
  }, {
    path: "/fr/:slug/presentations",
    component: _38b8fe76,
    name: "slug-presentations___fr"
  }, {
    path: "/fr/:slug/errors/:code?",
    component: _0b2b668f,
    name: "slug-errors-code___fr"
  }, {
    path: "/fr/:slug/horaire/:id",
    component: _070868a9,
    name: "slug-schedule-id___fr"
  }, {
    path: "/fr/:slug/participants/:id",
    component: _7074959c,
    name: "slug-participants-id___fr"
  }, {
    path: "/fr/:slug/presentations/:id",
    component: _2d34f06d,
    name: "slug-presentations-id___fr",
    children: [{
      path: "/fr/:slug/presentations/:id/affiche",
      component: _60288b5f,
      name: "slug-presentations-id-poster___fr"
    }, {
      path: "/fr/:slug/presentations/:id/diapositives",
      component: _23163474,
      name: "slug-presentations-id-slides___fr"
    }, {
      path: "/fr/:slug/presentations/:id/figures",
      component: _2c1ada6d,
      name: "slug-presentations-id-figures___fr"
    }, {
      path: "/fr/:slug/presentations/:id/video",
      component: _6729a059,
      name: "slug-presentations-id-video___fr"
    }]
  }, {
    path: "/:slug",
    component: _b8d3170a,
    name: "slug___en"
  }, {
    path: "/:slug/participants",
    component: _1d16284a,
    name: "slug-participants___en"
  }, {
    path: "/:slug/posters",
    component: _bf54f51c,
    name: "slug-posters___en"
  }, {
    path: "/:slug/presentations",
    component: _38b8fe76,
    name: "slug-presentations___en"
  }, {
    path: "/:slug/schedule",
    component: _d30c4bfe,
    name: "slug-schedule___en"
  }, {
    path: "/:slug/errors/:code?",
    component: _0b2b668f,
    name: "slug-errors-code___en"
  }, {
    path: "/:slug/participants/:id",
    component: _7074959c,
    name: "slug-participants-id___en"
  }, {
    path: "/:slug/presentations/:id",
    component: _2d34f06d,
    name: "slug-presentations-id___en",
    children: [{
      path: "/:slug/presentations/:id/figures",
      component: _2c1ada6d,
      name: "slug-presentations-id-figures___en"
    }, {
      path: "/:slug/presentations/:id/poster",
      component: _60288b5f,
      name: "slug-presentations-id-poster___en"
    }, {
      path: "/:slug/presentations/:id/slides",
      component: _23163474,
      name: "slug-presentations-id-slides___en"
    }, {
      path: "/:slug/presentations/:id/video",
      component: _6729a059,
      name: "slug-presentations-id-video___en"
    }]
  }, {
    path: "/:slug/schedule/:id",
    component: _070868a9,
    name: "slug-schedule-id___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
